import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

import { PageHeader } from 'components/page';
import { usePermissions } from 'hooks';
import Forbidden from 'pages/public/AccessDenied';
import { PageLoading } from 'pages/public/Loading';

import BDOTransferRequestList from '../transfer-requests/BDOTransferRequestList';
import AmexDinersPointsRedemption from './AmexDinersPointsRedemption';

const tabsItems = [
  { key: 'BRC/CC', label: 'BRC/CC' },
  { key: 'amex', label: 'AMEX' },
  { key: 'diners', label: 'Diners' }
];

const renderSettingsActionLink = (navigate: any) => {
  const handleSettingsClick = () => {
    navigate('/p/credit_card_redemption_settings');
  };

  return (
    <Button
      type="primary"
      size="large"
      data-testid="bdo-credit-card-requests-settings"
      onClick={handleSettingsClick}
    >
      Settings
    </Button>
  );
};

const BDOPointsRedemptions = () => {
  const { actions, loading } = usePermissions('points_redemptions');
  const [activeTab, setActiveTab] = useState('BRC/CC');
  const navigate = useNavigate();

  const [amexDinersKey, setAmexDinersKey] = useState(0);

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    if (key === 'amex' || key === 'diners') {
      setAmexDinersKey(prevKey => prevKey + 1);
    }
  };

  if (loading) return <PageLoading />;
  if (!actions?.includes('view') && !loading) return <Forbidden></Forbidden>;

  return (
    <>
      <PageHeader
        title="Points Redemptions"
        {...(actions.includes('configure') && {
          customAction: () => renderSettingsActionLink(navigate)
        })}
        tabs={tabsItems}
        onTabChange={handleTabChange}
      />
      {activeTab && activeTab === 'BRC/CC' ? (
        <BDOTransferRequestList />
      ) : (
        <AmexDinersPointsRedemption
          activeTab={activeTab}
          canConfigure={actions.includes('configure')}
          key={amexDinersKey}
        />
      )}
    </>
  );
};

export default BDOPointsRedemptions;
